import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-document-uploader',
  templateUrl: './document-uploader.component.html',
  styleUrls: ['./document-uploader.component.scss']
})
export class DocumentUploaderComponent implements OnInit {
  public loaded:boolean=false;
  public documents:Document[];
  public courseId;
  fileData: File = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  newFileType:string;
  newFileB64:string;
  newFileName:string;
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DocumentUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _course: CourseService
  ) { }

  ngOnInit() {
  }

  fileProgress(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      this.newFileType=file.type;
      this.newFileName=file.name;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  private _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.newFileB64= btoa(binaryString);
  }

  public resetUploader(){
    this.newFileB64='';
    this.newFileType='';
    this.fileInput.nativeElement.value = "";
  }

  public uploadNewDocument(){
    this._course.uploadDocument(this.newFileName, this.newFileType, this.newFileB64, this.data.courseId).subscribe(
      res=>{
        this.resetUploader();
        this.dialogRef.close(true);
      }
    );
  }

  close(){
    this.dialogRef.close(false);
  }

}
